'use client';
import { createCache } from '../cache/createCache/createCache.js';

/**
 * SSR-безопасный провайдер кэша на основе Map.
 * */ var InMemoryCache = createCache(function() {
    var storage = new Map();
    return {
        persist: function(ident, data) {
            storage.set(ident, data);
        },
        restore: function(ident) {
            return storage.get(ident);
        }
    };
});

export { InMemoryCache };
